export const PageHeader = ({ eyebrow, title, children }) => (
  <div className="rise mb-6 flex flex-wrap items-end justify-between gap-4">
    <div>
      <div className="label-xs !text-[#FF0000]">{eyebrow}</div>
      <h1 className="mt-1 text-3xl font-bold tracking-tight sm:text-4xl" data-testid="page-title">{title}</h1>
    </div>
    <div className="flex flex-wrap gap-2">{children}</div>
  </div>
);

export const KpiCard = ({ label, value, sub, accent = "#FF0000", testId, delay = 0 }) => (
  <div className="rise relative overflow-hidden rounded-lg border bg-white p-5 transition-shadow duration-300 hover:shadow-lg" style={{ animationDelay: `${delay}ms` }} data-testid={testId}>
    <span className="absolute left-0 top-0 h-full w-1" style={{ background: accent }} />
    <div className="label-xs">{label}</div>
    <div className="mt-2 font-display text-2xl font-bold tabular-nums sm:text-3xl">{value}</div>
    {sub && <div className="mt-1 text-xs text-slate-500">{sub}</div>}
  </div>
);

export const Panel = ({ title, children, className = "", action }) => (
  <div className={`rise rounded-lg border bg-white p-5 ${className}`}>
    <div className="mb-4 flex items-center justify-between"><h3 className="text-base font-semibold">{title}</h3>{action}</div>
    {children}
  </div>
);
